











import Vue from 'vue';
import { mapActions } from 'vuex';
import { Component } from 'vue-property-decorator';

import Layout from './components/Layout.vue';
import Cursor from './components/CustomCursor.vue';
import Navigation from './components/Navigation.vue';
import Button from './components/Button.vue';

import PageLevelLoader from './components/PageLevelLoader.vue';

import strings from './strings.json';

Object.defineProperty(Vue.prototype, '$strings', {
  get() {
    return (strings as any)[this.$store.state.language] || (strings as any).ru;
  }
});

Vue.component('v-layout', Layout);
Vue.component('v-navigation', Navigation);
Vue.component('v-button', Button);
Vue.component('v-loader', PageLevelLoader);

@Component({
  components: {
    'v-cursor': Cursor
  },
  methods: {
    ...mapActions({
      setLanguage: 'setLanguage'
    })
  }
})
export default class App extends Vue {
  public loading: boolean = false;

  get language() {
    return this.$store.state.language || 'ru';
  }

  public setLanguage(language: string = 'ru') {
    return this.$store.dispatch('setLanguage', language);
  }

  public loadLanguage() {
    return this.$store.dispatch('loadLanguage');
  }

  public mounted() {
    this.loadLanguage();
  }
}
